'use strict';

/**
 * Model for a single unit
 *
 * @category   Collection
 * @module     base
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Model = require('base/Colido.Model');

var UnitModel = Model.extend({
    api: '/core/units',

    idAttribute: 'key',

    defaults: {
        key: '',
        type: null,
        factor: 1, // Multiplication Factor for smallest unit
    },

    customAttributes: {
        name: function() {
            if (this.get('type') === 'size' || this.get('type') === 'length') {
                return App.t('global::units-sizes:' + this.get('key') + ':long');
            }

            if (this.get('type') === 'weight') {
                return App.t('global::units-weights:' + this.get('key') + ':long');
            }
        },
    },
});

module.exports = UnitModel;